<mat-sidenav-container>
    <mat-sidenav-content>
        <app-header />
        <router-outlet />
    </mat-sidenav-content>
    <mat-sidenav #sidenav mode="push" position="end" [(opened)]="opened" (opened)="events.push('open!')" (closed)="events.push('close!')">
        <app-menu />
    </mat-sidenav>
</mat-sidenav-container>
